<p-dialog [(visible)]="visible" (visibleChange)="onVisibleChange($event)" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="getModalStyle()" [header]="getHeaderTitle()" styleClass="form-response-viewer-dialog"
    [baseZIndex]="zIndex" [appendTo]="appendTo">

    <div class="response-viewer-content" [style.height]="'calc(' + modalHeight + ' - 120px)'" style="overflow-y: auto;">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="flex justify-content-center align-items-center" style="height: 200px;">
            <p-progressSpinner></p-progressSpinner>
            <span class="ml-3">{{ 'LOADING_SURVEY' | translate }}</span>
        </div>

        <!-- Error State -->
        <div *ngIf="errorMessage && !isLoading" class="flex flex-column justify-content-center align-items-center"
            style="height: 200px;">
            <i class="pi pi-exclamation-triangle text-red-500 mb-3" style="font-size: 3rem;"></i>
            <div class="text-center">
                <h4 class="text-900 mb-2">{{ 'ERROR_LOADING_SURVEY' | translate }}</h4>
                <p class="text-600 mb-0">{{ errorMessage }}</p>
            </div>
        </div>

        <!-- Survey Content -->
        <div *ngIf="surveyModel && !isLoading && !errorMessage" class="survey-container">
            <!-- Survey Form -->
            <survey [model]="surveyModel"></survey>
        </div>

        <!-- No Data State -->
        <div *ngIf="!data && !isLoading" class="flex flex-column justify-content-center align-items-center"
            style="height: 200px;">
            <i class="pi pi-info-circle text-blue-500 mb-3" style="font-size: 3rem;"></i>
            <div class="text-center">
                <h4 class="text-900 mb-2">{{ 'NO_DATA_AVAILABLE' | translate }}</h4>
                <p class="text-600 mb-0">{{ 'NO_RESPONSE_DATA_MESSAGE' | translate }}</p>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-between align-items-center w-full">
            <div class="text-600 text-sm">
                <i class="pi pi-info-circle mr-2"></i>
                {{ 'READ_ONLY_VIEW_MESSAGE' | translate }}
            </div>
            <div class="flex gap-2">
                <p-splitButton *ngIf="showDownloadButton" [label]="'DOWNLOAD_CSV' | translate" icon="pi pi-download"
                    severity="secondary" size="small" [model]="downloadMenuItems" (onClick)="onDownloadResponse()">
                </p-splitButton>
                <p-button *ngIf="showCloseButton" [label]="'CLOSE' | translate" icon="pi pi-times" severity="secondary"
                    size="small" (onClick)="onClose()">
                </p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>